export default {
    "ma50": {
        "he": {
            "name": "MA50",
            "explanation": "מרחק באחוזים מה־50MA, מציין אם המחיר מעל או מתחת."
        },
        "en": {
            "name": "MA50",
            "explanation": "Price % from 50MA, shows if above or below."
        }
    },
    "ma200": {
        "he": {
            "name": "MA200",
            "explanation": "מרחק באחוזים מה־200MA, מציין אם המחיר מעל או מתחת."
        },
        "en": {
            "name": "MA200",
            "explanation": "Price % from 200MA, shows if above or below."
        }
    },
    "yearlyRange": {
        "he": {
            "name": "טווח שנתי",
            "explanation": "מיקום המחיר בין שפל לשיא של השנה."
        },
        "en": {
            "name": "Yearly range",
            "explanation": "Price position within yearly high–low."
        }
    },
    "rsi": {
        "he": {
            "name": "RSI",
            "explanation": "מעל 70 קנייה יתר, מתחת 30 מכירה יתר."
        },
        "en": {
            "name": "RSI",
            "explanation": ">70 overbought, <30 oversold."
        }
    },
    "macd": {
        "he": {
            "name": "MACD",
            "explanation": "היסטוגרמה וכיוון: שורי או דובי."
        },
        "en": {
            "name": "MACD",
            "explanation": "Histogram and trend: bullish or bearish."
        }
    },
    "atrPercent": {
        "he": {
            "name": "ATR%",
            "explanation": "ATR באחוזים מהמחיר – מודד תנודתיות יחסית."
        },
        "en": {
            "name": "ATR%",
            "explanation": "ATR as % of price – measures relative volatility."
        }
    },
    "atrTrend": {
        "he": {
            "name": "מגמת ATR",
            "explanation": "כיוון התנודתיות: עולה, ניטרלי או יורד."
        },
        "en": {
            "name": "ATR trend",
            "explanation": "Volatility trend: up, neutral, or down."
        }
    },
    "obvTrend": {
        "he": {
            "name": "מגמת OBV",
            "explanation": "OBV מודד זרימת מחזור: עלייה = קנייה, ירידה = מכירה."
        },
        "en": {
            "name": "OBV trend",
            "explanation": "OBV shows volume flow: rising = buying, falling = selling."
        }
    }
}
